import { Injectable } from '@angular/core';
import { MapsAPILoader } from '@agm/core';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private geoCoder: google.maps.Geocoder;

  constructor(private mapsAPILoader: MapsAPILoader) {}

  /**
   * Load Google Maps API and get location
   * @returns Promise with lat/lng or error
   */
  loadGoogleMapsAndSetLocation(): Promise<{ lat: number; lng: number }> {
    return new Promise((resolve, reject) => {
      this.mapsAPILoader.load().then(() => {
        this.geoCoder = new google.maps.Geocoder();
        this.getUserLocation()
          .then((coords) => resolve(coords))
          .catch((error) => reject(error));
      }).catch(() => {
        reject('Failed to load Google Maps API.');
      });
    });
  }

  /**
   * Get user's current location
   */
  getUserLocation(): Promise<{ lat: number; lng: number }> {
    return new Promise((resolve, reject) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
          },
          (error) => {
            if (error.code === error.PERMISSION_DENIED) {
              reject('Location access denied. Please enable it in browser settings.');
            } else {
              reject('Failed to get location.');
            }
          }
        );
      } else {
        reject('Geolocation is not supported by your browser.');
      }
    });
  }
}
